/* WJW 28 — keep ParcelWILL's one actual cart-page widget visible at the
   relevant checkout location. Do not clone it, fake its checked state, or
   create a second protection product. Its original checkout mount is preserved.

   Cart top: Order Summary; long-cart middle: floating checkout;
   cart bottom: ParcelWILL's own original spot above native checkout.
   The cart drawer's separately injected widget is never moved. */
(() => {
  'use strict';
  if (window.__wjwInc28NativeProtection) return;
  window.__wjwInc28NativeProtection = true;
  if (!document.body.classList.contains('template-cart')) return;

  const mobile = window.matchMedia('(max-width:749px)');
  let vendor = null;
  let originalMarker = null;
  let originalParent = null;
  let scheduled = false;
  let vendorObserver = null;

  const locate = () => Array.from(document.querySelectorAll('#return-widget')).find(el =>
    !el.closest('#Cart-Drawer') &&
    !el.closest('#Product-Drawer') &&
    el.querySelector('.return-widget-button')) || null;

  function rememberOriginal(node) {
    // The vendor is initially inserted above the native checkout button.
    // Record that real DOM position before moving it into either mobile slot.
    if (node.closest('[data-wjw-protection-slot]')) return;
    originalParent = node.parentNode;
    if (!originalParent) return;
    originalMarker = document.createComment('WJW: ParcelWILL original checkout mount');
    originalParent.insertBefore(originalMarker, node);
  }

  function returnToNativeCheckout(node, cart) {
    if (originalMarker?.isConnected && originalMarker.parentNode) {
      if (node.previousSibling !== originalMarker || node.parentNode !== originalMarker.parentNode) {
        originalMarker.parentNode.insertBefore(node, originalMarker.nextSibling);
      }
      return;
    }
    // Shopify/ParcelWILL may replace the original mount while rebuilding cart
    // markup. Never leave the real widget stranded in an invisible sticky slot.
    const checkout = cart.querySelector('#wjw-cart-checkout');
    if (checkout?.parentNode && node.nextSibling !== checkout) {
      checkout.parentNode.insertBefore(node, checkout);
    }
  }

  function update() {
    scheduled = false;
    const cart = document.querySelector('body.template-cart #Cart');
    if (!cart) return;
    const summary = cart.querySelector('[data-wjw-protection-slot="summary"]');
    const floating = cart.querySelector('[data-wjw-cart-sticky]');
    const sticky = cart.querySelector('[data-wjw-protection-slot="sticky"]');
    const checkout = cart.querySelector('#wjw-cart-checkout');
    if (!summary || !floating || !sticky || !checkout) return;

    // Vendor can replace the button during an asynchronous fee update.
    // Retain the connected root while its inner button is temporarily absent.
    const candidate = locate() ||
      (vendor?.isConnected && vendor.closest('[data-wjw-protection-slot]') ? vendor : null);
    if (candidate !== vendor) {
      vendorObserver?.disconnect();
      vendorObserver = null;
      if (originalMarker?.parentNode) originalMarker.remove();
      originalMarker = null;
      originalParent = null;
      vendor = candidate;
      if (vendor) {
        rememberOriginal(vendor);
        vendorObserver = new MutationObserver(schedule);
        vendorObserver.observe(vendor, {childList:true,subtree:true,attributes:true});
      }
    }
    if (!vendor || !vendor.isConnected) return;

    if (!mobile.matches) {
      returnToNativeCheckout(vendor, cart);
      return;
    }

    const overlayOpen = document.body.classList.contains('wjw-mobile-overlay-active') ||
      !!document.querySelector('#Cart-Drawer.active,#Product-Drawer.active');
    const showSticky = floating.classList.contains('is-visible') && !overlayOpen;
    const checkoutRect = checkout.getBoundingClientRect();
    const nearNativeCheckout = checkoutRect.top < window.innerHeight - 105;

    if (showSticky) {
      if (vendor.parentNode !== sticky) sticky.appendChild(vendor);
    } else if (nearNativeCheckout) {
      // This is the missing Increment 27 branch: restore the real switch just
      // above the native checkout when the floating bar is no longer needed.
      returnToNativeCheckout(vendor, cart);
    } else if (vendor.parentNode !== summary) {
      summary.appendChild(vendor);
    }
  }

  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
  }

  function boot() {
    // Watch for an asynchronously re-injected vendor widget and Shopify AJAX
    // section replacements. Mutation loops stop because moves are conditional.
    new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
    const floating = document.querySelector('body.template-cart #Cart [data-wjw-cart-sticky]');
    if (floating) new MutationObserver(schedule).observe(floating,{attributes:true,attributeFilter:['class']});
    mobile.addEventListener('change',schedule);
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    document.addEventListener('cart:refresh',schedule);
    document.addEventListener('line-item:change:end',schedule);
    window.addEventListener('pageshow',schedule);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
